import { render, staticRenderFns } from "./PropertyRow.vue?vue&type=template&id=10846b06&scoped=true&"
import script from "./PropertyRow.vue?vue&type=script&lang=js&"
export * from "./PropertyRow.vue?vue&type=script&lang=js&"
import style0 from "./PropertyRow.vue?vue&type=style&index=0&id=10846b06&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10846b06",
  null
  
)

export default component.exports